import { useState, useEffect, useMemo } from 'react';
import { Iread_BASE_URL } from '../Constant/constant';

const useIreadSearch = (searchBookName) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null); // ✅ 加入 error 狀態

  const libraries = useMemo(
    () => [
      { name: '基隆市文化局', baseUrl: 'https://klccab.airitibooks.com' },
      { name: '臺南市立圖書館', baseUrl: 'https://tnml.airitibooks.com' },
    ],
    []
  );

  useEffect(() => {
    if (!searchBookName || libraries.length === 0) {
      setResults([]);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchAll = async () => {
      setLoading(true);
      setError(null);
      const map = new Map();

      try {
        await Promise.all(
          libraries.map(async ({ name, baseUrl }) => {
            try {
              const res = await fetch(`${Iread_BASE_URL}/api/airiti/search`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ keyword: searchBookName, baseUrl }),
              });

              const json = await res.json(); // [{ title, id }]

              json.forEach(({ title, id }) => {
                const url = `${baseUrl}/Detail/Detail?PublicationID=${id}&DetailSourceType=2`;
                if (!map.has(title)) map.set(title, []);
                map.get(title).push({ name, link: url });
              });
            } catch (err) {
              console.warn(`Fail from ${name}`, err);
              // 不中斷整體流程，只記錄 warning
            }
          })
        );

        const transformed = Array.from(map.entries()).map(
          ([title, libraries]) => ({
            title,
            libraries,
          })
        );

        setResults(transformed.slice(0, 10));
      } catch (err) {
        setError(err);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [libraries, searchBookName]);

  return { results, loading, error }; // ✅ 回傳 error 給 UI
};

export default useIreadSearch;
